// HashtagCategoryList.js
'use strict';
import { connect } from 'react-redux';

import {
  TRENDING_HASHTAG_FEED,
  TRENDING_CATEGORY_FEED,
  TRENDING_CATEGORY_FETCH_LIMIT,
} from '../RemoteConfigKeys.js';

import HashtagCategoryList from '../component/HashtagCategoryList.jsx';

import fetchTranslationByKey from '../action/fetchTranslationByKey.js';
import fetchFeeds from '../action/fetchFeeds.js';
import getListData from '../selector/getListData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getMeData from '../selector/getMeData.js';
import { getFeedNameType } from '../resource/feedUtils.js';

const PSEUDO_TRENDING_CATEGORY = 'pseudo_trending_category';

const mapStateToProps = (state, { category }) => {
  const trendingHashtagFeed = getRemoteConfigData(state, TRENDING_HASHTAG_FEED);
  const trendingCategoryFeed = getRemoteConfigData(
    state,
    TRENDING_CATEGORY_FEED
  );
  const trendingCategoryFetchLimit = getRemoteConfigData(
    state,
    TRENDING_CATEGORY_FETCH_LIMIT
  );
  const isTrendingMessageCategory = PSEUDO_TRENDING_CATEGORY === category;
  return {
    meId: getMeData(state, 'id'),
    category,
    trendingHashtagFeed,
    trendingCategoryFeed,
    trendingCategoryFetchLimit,
    isTrendingMessageCategory,
    items: isTrendingMessageCategory
      ? getListData(
          state,
          [
            'home',
            getFeedNameType({ feedName: trendingCategoryFeed }),
            trendingCategoryFeed,
          ],
          'itemIds'
        )
      : getListData(
          state,
          [
            'home',
            getFeedNameType({ feedName: trendingHashtagFeed }),
            trendingHashtagFeed,
          ],
          'itemIds'
        ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchTranslationByKey: ({ groups }) =>
      dispatch(fetchTranslationByKey({ groups })),
    fetchFeeds: data => dispatch(fetchFeeds(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HashtagCategoryList);
